// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"24925904","1":"f8977fcb","22":"eb48e33c","85":"693c86c0","156":"fbe8f69c","200":"7c3cdf26","300":"6696184e","362":"12c2d114","439":"20aae719","652":"99694413","909":"99defd51"}[chunkId] + ".chunk.js";
};